var styleDataHash = '659daee7';  
export const injectCss = (() => {
  var css = `.wvZpi{height:100%;position:absolute;top:0;width:100%;z-index:0}[dir] .wvZpi{border:0}[dir=ltr] .wvZpi{left:0}[dir=rtl] .wvZpi{right:0}.Wf9Xl{bottom:0;position:absolute;top:0;z-index:3}[dir=ltr] .Wf9Xl,[dir=rtl] .Wf9Xl{left:0;right:0}.LqvMN{height:0;position:relative}[dir] .LqvMN{padding-bottom:56.25%}@supports not (contain:inline-size){@media only screen and (max-width:640px){.LqvMN{min-width:auto}}}@container (width < 640px){.LqvMN{min-width:auto}}._8Azvt,.glob_fontElementMap{font-family:var(--ricos-font-family,unset)}._0qbCG{--ricos-custom-p-font-size:14px;color:var(--ricos-custom-p-color,unset);display:block;font-family:var(--ricos-custom-p-font-family,unset);font-size:var(--ricos-custom-p-font-size,unset);font-style:var(--ricos-custom-p-font-style,unset);font-weight:var(--ricos-custom-p-font-weight,unset);justify-content:center;letter-spacing:var(--ricos-custom-p-letter-spacing,unset);line-height:var(--ricos-custom-p-line-height,unset);min-height:var(--ricos-custom-p-min-height,unset);padding-inline:16px;text-align:center;text-decoration:var(--ricos-custom-p-text-decoration,unset)}._0qbCG>span>a,._0qbCG>span>span{background-color:var(--ricos-custom-p-background-color,unset)}@supports not (contain:inline-size){@media only screen and (max-width:640px){._0qbCG{font-size:var(--ricos-custom-p-font-size,unset)}}}@container (width < 640px){._0qbCG{font-size:var(--ricos-custom-p-font-size,unset)}}.omglR{display:block!important;margin:12px 0}`;
  var isTest = typeof process !== 'undefined' && process.env && process.env['NODE_ENV'] === 'test';

  if (isTest || !css || typeof document === 'undefined') { return; }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.setAttribute('data-ricos-style-hash', styleDataHash);
  style.type = 'text/css';

  head.appendChild(style);

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});





